// extracted by css-extract-rspack-plugin
export default {"cls1":"CitationModal-cls1_8K0","cls2":"CitationModal-cls2_2O1 CitationModal-cls1_8K0"};